import {CONSTANTS} from '@/constants'
import { functions } from '@/functions';

export const functions_voucher_actions = {
    data: function () {
        return {
            cancel_recycle: false,
            cancel_drop: false,
            revoke_booking_only: false,
        };
    },
    mixins: [functions],
    components: { },
    computed: { },
    methods: {
        doCancel: function() {
            if (!this.cancel_recycle) {

                let cmd = '/cancel';
                if (this.cancel_drop) {
                    cmd = '/drop';
                }
                else {
                    if (this.revoke_booking_only) {
                        cmd = '/refuse';
                    }
                }
                this.httpPrepare();
                this.$http.put(this.apiurl('voucher/' + this.voucher.id + cmd), {reason: this.reason}).then(function (response) {
                    this.httpSuccess(response);
                    this.doGoBack();
                }, this.httpError);
            }
            else {

                this.httpPrepare();
                this.$http.post(this.apiurl('voucher/'+this.voucher.id+'/recycle'), {reason: this.reason} ).then(function (response) {
                    response = this.httpSuccess(response);
                    if (response.result === 'success')
                    {
                        this.$router.push({ path: '/agent/voucher/'+response.payload})
                    }
                    else {
                        this.error_log(response.error);
                    }
                }, this.httpError)
            }
        },

        doRevoke: function() {
            this.httpPrepare();
            this.$http.put(this.apiurl('voucher/' + this.voucher.id + '/revoke'), {reason: this.reason, penalty:this.penalty}).then(function (response) {
                this.httpSuccess(response);
                this.doGoBack();
            }, this.httpError);
        },

        doAccept: function() {
            this.httpPrepare();
            this.$http.put(this.apiurl('voucher/' + this.voucher.id + '/accept') ).then(function (response) {
                this.httpSuccess(response);
                this.doGoBack();
            }, this.httpError);
        },

        doAnnul: function() {
            this.httpPrepare();
            this.$http.put(this.apiurl('voucher/' + this.voucher.id + '/annul'), {reason: this.reason, penalty:this.penalty}).then(function (response) {
                this.httpSuccess(response);
                this.doGoBack();
            }, this.httpError);
        },

        doAssignCustomer: function(customer_id) {
            this.httpPrepare();
            this.$http.put(this.apiurl('voucher/' + this.voucher.id + '/assign-customer'), {customer_id: customer_id}).then(function (response) {
                this.httpSuccess(response);
                this.reloadView();
            }, this.httpError);
        },

        doCreateCustomer: function() {
            this.httpPrepare();
            this.$http.put(this.apiurl('voucher/' + this.voucher.id + '/create-customer')).then(function (response) {
                this.httpSuccess(response);
                this.reloadView();
            }, this.httpError);
        },

        doUpdateStatusCloseTime: function() {

            let data = {
                close_status_at: dateTimeToISO(this.voucher.close_status_at),
                status_action_info: this.voucher.status_action_info
            };

            console.log('data', data);

            this.httpPrepare();
            this.$http.put(this.apiurl('voucher/' + this.voucher.id + '/status-close-time'), data).then(function (response) {
                this.httpSuccess(response);
                this.reloadVoucher();
            }, this.httpError);
        },
    },
};
